// @flow
import React, { memo } from 'react';
import {
  Notification,
  NotificationsWrapper,
} from 'box-ui-elements/es/components/notification';
import { Button } from '@box/blueprint-web';
import { injectIntl, FormattedMessage } from 'react-intl';
import type { InjectIntlProvidedProps } from 'react-intl';
import messages from './messages';
import './form-error-notification.module.scss';

type Props = {
  errorMessage?: Object,
  onClose: Function,
} & InjectIntlProvidedProps;

const FormErrorNotification = memo<Props>((props: Props) => {
  const { errorMessage, onClose, intl } = props;
  const displayButton =
    errorMessage && errorMessage.values && errorMessage.values.info;

  if (errorMessage) {
    return (
      <NotificationsWrapper>
        <Notification duration="short" onClose={onClose} type="error">
          <span>
            <FormattedMessage {...errorMessage} />
          </span>
          {displayButton && (
            <Button
              onClick={() =>
                window.open(errorMessage.values.info, '_blank', 'noreferrer')
              }
              size="small"
              variant="outline"
            >
              {intl.formatMessage(messages.infoButtonLabel)}
            </Button>
          )}
        </Notification>
      </NotificationsWrapper>
    );
  }
  return null;
});

export { FormErrorNotification };
export default injectIntl(FormErrorNotification);
